import { ReactNode } from 'react';
import { SidebarMenu } from '@ardoq/sidebar-menu';
import { SidebarLayout, type SidebarLayoutProps } from '@ardoq/sidebar';
import { useWindowSize } from '@ardoq/hooks';

type DrawerProps = Pick<
  SidebarLayoutProps,
  | 'shouldCoverContent'
  | 'shadow'
  | 'shouldCloseOnExternalClick'
  | 'shouldCloseOnEscKeyPress'
> & {
  isOpen: boolean;
  sidebarContent: ReactNode;
  drawerHeaderBody?: ReactNode;
  drawerTitle?: string;
  drawerHeaderLeftContent?: ReactNode;
  zIndex?: number;
  onClose: VoidFunction;
};

export const Drawer = ({
  isOpen,
  drawerTitle,
  drawerHeaderBody,
  drawerHeaderLeftContent,
  sidebarContent,
  zIndex,
  onClose,
  shouldCoverContent = true,
  shadow,
  shouldCloseOnExternalClick = false,
  shouldCloseOnEscKeyPress = true,
}: DrawerProps) => {
  const { width: windowWidth } = useWindowSize();
  return (
    <SidebarLayout
      hideSidebarWhenClosed
      isOpen={isOpen}
      alignment="right"
      width={windowWidth < 600 ? '100vw' : '600px'}
      shouldCoverContent={shouldCoverContent}
      shadow={shadow}
      onClose={onClose}
      shouldCloseOnExternalClick={shouldCloseOnExternalClick}
      shouldCloseOnEscKeyPress={shouldCloseOnEscKeyPress}
      zIndex={zIndex}
    >
      {isOpen && (
        <SidebarMenu
          headerLeftContent={drawerHeaderLeftContent}
          headerTitle={drawerTitle}
          headerBody={drawerHeaderBody}
          onCloseClick={onClose}
        >
          {sidebarContent}
        </SidebarMenu>
      )}
    </SidebarLayout>
  );
};
